import styled from 'styled-components/macro';
import { Link } from 'react-router-dom';

export const LinkText = styled(Link)`
  text-decoration: none;
  font-size: 1.4rem;
  color: ${({ theme }) => theme.primary.xlight};
`;
